/* eslint-disable no-unused-vars */

import { PricingUtils } from "./PricingUtils";
import db from "../db/db";
import API from "./API";
import { StringUtils } from "./StringUtils";

export const SaleUtils = {
  getValidPromotions,
  getCategory,
  getPromotions,
  populateCount,
  applyPromotion,
  applyPromotionPhase1,
  applyPromotionWrapper,
  distributeDiscount,
  updateSaleData,
  updateProduct,
  getCurrentRow,
  findRowSaleIndexByKey,

  addProductNew,
  deriveKey,
  isProductExist,
  isSaleAllowed,
  getOption,
  getOption2,
  getOption3,
  getShiftSaleSession,
  getShiftSaleSessionId,
  getProductCostFromBatch,
  getProductCostFromBatchWithQty,
  getStoreCostingMethodeCode,
};

async function getProductCostFromBatch(batchList, costingMethode, defaultCost) {
  if (!defaultCost) {
    defaultCost = 0.0;
  }
  let effectiveCost = defaultCost;
  try {
    if (batchList && Array.isArray(batchList) && batchList.length > 0) {
      if (costingMethode === "LIFO") {
        if (
          batchList[batchList.length - 1] &&
          batchList[batchList.length - 1].currentCost
        ) {
          effectiveCost = batchList[batchList.length - 1].currentCost;
        }
      } else if (costingMethode === "FIFO") {
        effectiveCost = batchList[0].currentCost;
      } else {
        //AVERAGE costing [Weighted average calculation methode is applied]
        let toatlCost = 0;
        let totalQty = 0;
        for (let i = 0; i < batchList.length; i++) {
          toatlCost +=
            parseFloat(batchList[i].currentCost) *
            parseFloat(batchList[i].remainingQty);
          totalQty += parseFloat(batchList[i].remainingQty);
        }
        effectiveCost = toatlCost / (totalQty == 0 ? 1 : totalQty);
      }
    } else {
      console.log("ERROR-", "Batch list is not correct");
    }
  } catch (err) {
    console.log("ERROR-", "Something went wrong while get cost from batch");
  } finally {
    return effectiveCost;
  }
}
async function getProductCostFromBatchWithQty(
  batchList,
  costingMethode,
  defaultCost,
  quantity,
  context,
  decimal
) {
  if (!defaultCost) {
    defaultCost = 0.0;
  }
  if (!quantity) {
    quantity = 0;
  }
  let effectiveCost = defaultCost;
  let requiredQty = quantity;
  try {
    if (batchList && batchList.length > 0) {
      if (costingMethode && costingMethode === "LIFO") {
        batchList = batchList.reverse();
      }
      if (
        costingMethode &&
        (costingMethode === "LIFO" || costingMethode === "FIFO")
      ) {
        let toatlCost = 0;
        let totalQty = 0;
        for (let i = 0; i < batchList.length; i++) {
          let availableQtyInBatch = parseFloat(batchList[i].remainingQty);
          if (availableQtyInBatch >= requiredQty) {
            toatlCost +=
              parseFloat(batchList[i].currentCost) * parseFloat(requiredQty);
            totalQty += parseFloat(requiredQty);
            break;
          } else {
            toatlCost +=
              parseFloat(batchList[i].currentCost) *
              parseFloat(availableQtyInBatch);
            totalQty += parseFloat(availableQtyInBatch);
            requiredQty = requiredQty - availableQtyInBatch;
          }
        }
        effectiveCost = toatlCost / (totalQty == 0 ? 1 : totalQty);
      } else {
        //AVERAGE costing [Weighted average calculation methode is applied]
        let toatlCost = 0;
        let totalQty = 0;
        for (let i = 0; i < batchList.length; i++) {
          toatlCost +=
            parseFloat(batchList[i].currentCost) *
            parseFloat(batchList[i].remainingQty);
          totalQty += parseFloat(batchList[i].remainingQty);
        }
        effectiveCost = toatlCost / (totalQty == 0 ? 1 : totalQty);
      }
    } else {
      console.log(
        "ERROR-",
        "Batch list is not correct! will return the default cost:",
        defaultCost
      );
    }
  } catch (err) {
    console.log(
      "ERROR-",
      "Something went wrong while get cost from batch! will return the default cost:",
      defaultCost
    );
  } finally {
    effectiveCost = StringUtils.formattedNumberWithStoreDecimal(
      effectiveCost,
      context,
      decimal
    );

    return effectiveCost;
  }
}

function getShiftSaleSessionId(saleSession) {
  let sess = getShiftSaleSession(saleSession);
  if (sess) {
    return sess.id;
  }
  return null;
}

function getShiftSaleSession(saleSession) {
  if (
    saleSession.shiftSaleSessions &&
    saleSession.shiftSaleSessions.length > 0
  ) {
    return saleSession.shiftSaleSessions[
      saleSession.shiftSaleSessions.length - 1
    ];
  }
  return null;
}

function getOption(options, key) {
  for (let d of options) {
    if (key === d.id) return d;
  }
  return null;
}
function getOption2(options, key) {
  for (let d of options) {
    if (key === d.value) return d;
  }
  return null;
}
function getOption3(options, key) {
  for (let d of options) {
    if (key === d.name) return d;
  }
  return null;
}

function isProductExist(rawData, key) {
  let i = 0;
  for (let d of rawData) {
    if (d.key === key) {
      return i;
    }
    i++;
  }
  return -1;
}

function deriveKey(data, productId, pricingUnitType, returnFlag, suffix) {
  let key =
    productId +
    "-" +
    pricingUnitType +
    (returnFlag ? "-return-" + data.length + 1 : "") +
    (suffix ? suffix : "");
  return key;
}

async function addProductNew(
  rawSaleData,
  setRawSale,
  setSaleData,
  colorPallet,
  context,
  productBean,
  pricingBean,
  price,
  qty,
  returnFlag,
  key,
  extax,
  serviceMeta,
  changeReturnFlag
) {
  var rawData = [...rawSaleData];

  if (
    productBean.kitItems != null &&
    productBean.kitItems != undefined &&
    productBean.isKit != null &&
    productBean.isKit != undefined &&
    productBean.isExpandKitDuringSale != null &&
    productBean.isExpandKitDuringSale != undefined &&
    productBean.isExpandKitDuringSale == true
  ) {
    for (let i = 0; i < productBean.kitItems.length; i++) {
      let dbData = await db.product
        .where("id")
        .equals(productBean.kitItems[i].productId)
        .toArray();
      if (dbData[0] != null && dbData[0] != undefined) {
        let key = deriveKey(
          dbData[0].id,
          dbData[0].productPricingBeanList[0].unitType,
          returnFlag
        );

        let position = isProductExist(rawSaleData, key);
        if (position >= 0) {
          updateProduct(
            position,
            "addQty",
            parseFloat(productBean.kitItems[i].quantity)
          );
        } else {
          let newKey = SaleUtils.deriveKey(
            rawData,
            dbData[0].id,
            dbData[0].productPricingBeanList[0].unitType,
            returnFlag
          );

          rawData.push({
            index: rawData.length,
            productBean: dbData[0],
            pricingBean: dbData[0].productPricingBeanList[0],
            price: dbData[0].productPricingBeanList[0].price,
            qty: parseFloat(productBean.kitItems[i].quantity),
            returnFlag: returnFlag,
            discountFlag: returnFlag ? false : productBean.isDiscounted,
            key: newKey,
            exTax: extax,
            saleItemNote: "",
            serviceMeta: serviceMeta,
          });
        }
      }
    }
  } else {
    rawData.push({
      index: rawData.length,
      productBean: productBean,
      pricingBean: pricingBean,
      price: price,
      qty: qty,
      returnFlag: returnFlag,
      discountFlag: returnFlag ? false : productBean.isDiscounted,
      key: key,
      exTax: extax,
      saleItemNote: "",
      serviceMeta: serviceMeta,
    });
  }

  setRawSale(rawData);
  //addProduct(productBean, pricingBean, price, qty, key);
  //updateSaleData(rawData, key, changeReturnFlag);

  let tSaleData = await updateSaleData(
    rawData,
    key,
    context.store.currencyDecimal,
    colorPallet,
    changeReturnFlag,
    context
  );

  setSaleData(tSaleData[0]);
}

function findRowSaleIndexByKey(rawData, key) {
  let i = 0;
  for (let d of rawData) {
    if (d.key == key) {
      return i;
    }
    i++;
  }
  return -1;
}

function getCurrentRow(data) {
  let i = 0;
  for (let d of data) {
    if (d[9].info.selected) {
      return i;
    }
    i++;
  }
  return -1;
}

async function distributeDiscount(saleData, discount, decimal) {
  let totalExPromoted = 0;
  for (let d of saleData) {
    if (d[9].info.hasPromotion || d[9].info.discountAmount > 0) {
    } else {
      totalExPromoted = totalExPromoted + parseFloat(d[8].v);
    }
  }
  for (let d of saleData) {
    if (
      d[9].info.hasPromotion ||
      discount == 0 ||
      d[9].info.discountAmount > 0
    ) {
      d[9].info.finalPrice = d[9].info.price;
      d[9].info.finalNetAmount = d[8].v;
      d[9].info.finalNetTaxAmount = d[7].v;
      d[9].info.finalPromotionPercentage = d[9].info.discountPer;
      d[9].info.finalPromotionAmount = d[9].info.discountAmount;
    } else {
      d[9].info.distPer = (parseFloat(d[8].v) / totalExPromoted) * 100;
      d[9].info.finalNetAmount =
        parseFloat(d[8].v) - (discount * d[9].info.distPer) / 100;
      let oldPrice = parseFloat(d[8].v) / d[5].v;

      let newPrice = d[9].info.finalNetAmount / d[5].v;

      let discountPer = ((oldPrice - newPrice) / totalExPromoted) * 100;

      let result = PricingUtils.derivePrice(
        decimal,
        0,
        newPrice,
        true,
        d[9].info.productBean.taxBean.rate,
        true,
        discountPer,
        null,
        true,
        d[5].v,
        d[9].info.returnFlag
      );

      d[9].info.finalPrice = result.retailSalePrice;
      d[9].info.finalNetAmount = result.netAmount;
      d[9].info.finalNetTaxAmount = result.netTax;
      d[9].info.finalPromotionPercentage = result.promotionPersentage;
      d[9].info.finalPromotionAmount = result.promotionAmount;
    }
  }
}

function populateCount(tree, data) {
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      let cnt = refreshTree(data, tree[key]);
      for (let prod of value.products) {
        cnt = cnt + prod.count;
      }
      value.count = cnt;
    }
  }
}

function applyPromotionPhase1(tree, data) {
  populateCount(tree, data);
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      deriveValidPromotions(value, data, value.count);
    }
  }
}

async function applyPromotionWrapper(
  tree,
  data,
  tags,
  decimal,
  colorPallet,
  currentKey,
  context
) {
  applyPromotion(tree, data, tags);

  let saleList = applyPromotionToTheSaleList(tree, data, tags);
  let newSaleList = consolidateSaleList(saleList, data, colorPallet);
  //colorTag(newSaleList, colorPallet);
  await populatePricing(newSaleList, data, decimal, context);
  let saleData = convertToUiCompatibleList(newSaleList, data, currentKey);

  return [saleData, newSaleList];
}

function convertToUiCompatibleList(newSaleList, data, currentKey) {
  let i = 1;
  let saleData = [];
  let selectedIx = 0;
  for (let sale of newSaleList) {
    if (sale.key == currentKey) {
      selectedIx = i - 1;
    }
    let saleItem = [
      { v: i, color: sale.color },
      { v: sale.code },
      {
        v: sale.returnFlag ? "[Return]" + sale.prodName : sale.prodName,
      },
      { v: sale.price },
      { v: sale.unitType },
      { v: sale.qty },
      { v: sale.discountPer },
      { v: sale.netTax },
      { v: sale.netAmount },
      {
        info: {
          hasPromotion: sale.tagName,
          selected: false,
          productBean: data[sale.index].productBean,
          pricingBean: data[sale.index].pricingBean,
          serviceMeta: data[sale.index].serviceMeta,
          key: sale.key,
          price: sale.price,
          retailSalePrice: sale.retailSalePrice,
          discountPer: sale.discountPer,
          discountAmount: sale.discountAmount,
          returnFlag: sale.returnFlag,
          tag: sale.tagName,
          origPrice: data[sale.index].pricingBean.price,
          saleItemNote: data[sale.index].saleItemNote,
          productInfoField1: data[sale.index].productBean.productInfoField1,
          productInfoField2: data[sale.index].productBean.productInfoField2,
          productInfoField3: data[sale.index].productBean.productInfoField3,
          productInfoField4: data[sale.index].productBean.productInfoField4,
          productInfoField5: data[sale.index].productBean.productInfoField5,
          productInfoField6: data[sale.index].productBean.productInfoField6,
        },
      },
    ];
    saleData.push(saleItem);
    i++;
  }
  if (saleData.length > 0) saleData[selectedIx][9].info.selected = true;
  return saleData;
}

async function populatePricing(saleList, data, decimal, context) {
  for (let sale of saleList) {
    sale["code"] = data[sale.index].productBean.code;

    let price = data[sale.index].price;
    let discountPer = sale.discountPer;

    if (sale.type == "PRODUCT_LEVEL_PRICING") {
      discountPer =
        100 -
        (parseFloat(sale.productLevelPromotionPrice) / parseFloat(price)) * 100;
    }

    //let incDiscInPrice = data[sale.index].productBean.includeDiscountInPrice;
    let taxInPrice = data[sale.index].productBean.includeTaxInPrice;
    if (!(sale.customPrice == undefined || sale.customPrice == "null")) {
      price = sale.customPrice;
      taxInPrice = sale.includeTaxInAdjustedPrice ? true : false;
    }

    let isDiscountedFlag = data[sale.index].productBean.isDiscounted;
    if (sale.customDiscountPer) {
      discountPer = sale.customDiscountPer;
      isDiscountedFlag = true;
    }
    if (sale.customDiscountAmount) {
      //console.log(sale);
      discountPer = (sale.customDiscountAmount / parseFloat(price)) * 100;
      isDiscountedFlag = true;
    }

    //console.log(data[sale.index].productBean);
    let result = PricingUtils.derivePrice(
      decimal,
      0,
      price,
      taxInPrice,
      data[sale.index].productBean.taxBean.rate,
      data[sale.index].productBean.includeDiscountInPrice,
      discountPer,
      null,
      isDiscountedFlag,
      sale.qty,
      data[sale.index].returnFlag,
      data[sale.index].customDiscountAmount,
      context.saleSetting.discountOnFinalPrice
    );

    // console.log("FFC-", JSON.stringify(result, null, 4));

    sale["unitType"] = data[sale.index].pricingBean.unitType;
    //sale["qty"] = sale.qty;
    sale["discountPer"] = result.promotionPersentage;
    sale["netAmount"] = result.netAmount;
    sale["netTax"] = result.netTax;
    sale["price"] = result.price;
    sale["retailSalePrice"] = result.retailSalePrice;
    sale["returnFlag"] = data[sale.index].returnFlag;
    sale["discountAmount"] = result.promotionAmount;
  }
}

function consolidateSaleList(saleList, data, colorPallet) {
  let newSaleList = [];
  for (let i = 0; i < data.length; i++) {
    let m = {};
    for (let sale of saleList) {
      if (i == sale.index) {
        if (sale.tagName) {
          let key =
            sale.key +
            "_" +
            sale.discountPer +
            (sale.type === "FREE" ? sale.tagName : "");
          if (!m[key]) {
            m[key] = sale;
          } else {
            m[key].qty = m[key].qty + sale.qty;
          }
        } else {
          m["z-lonely" + sale.key] = sale; //
        }
      }
    }
    let colorMap = {};
    let ix = 0;
    if (colorPallet) {
      for (let sale of saleList) {
        if (sale.tagName && !colorMap[sale.tagName]) {
          colorMap[sale.tagName] = colorPallet[ix % 10];
          ix++;
        }
      }
    }
    for (const [key, sale] of Object.entries(m)) {
      if (sale.tagName) {
        if (colorMap[sale.tagName]) {
          sale["color"] = colorMap[sale.tagName];
        } else {
          sale["color"] = "hsl(120, 100%, 100%)";
        }
      } else {
        sale["color"] = "transparent";
      }
      newSaleList.push(sale);
    }
  }
  return newSaleList;
}

function getRandomColor() {
  let color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
  return color;
}

function applyPromotionToTheSaleList(tree, data, tags) {
  let saleList = [];
  for (let tag of tags) {
    let prodList = [];
    for (const [key, value] of Object.entries(tree)) {
      if (key.startsWith("--category--")) {
        identifyTaggedProducts(tag, value, prodList, data);
      }
    }
    if (tag.type === "FREE") {
      processFreeTypePromotion(prodList, tag, data, saleList);
    } else {
      for (let prod of prodList) {
        saleList.push(createSaleEntry(tag, prod, data));
      }
    }
  }
  //Look for non tagged products

  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      identifyNonTaggedProducts(value, saleList, data);
    }
  }
  return saleList;
}

function processFreeTypePromotion(prodList, tag, data, saleList) {
  let buy = tag.promo.promos[0].validRules[0].ruleBuyLimit;
  let get = tag.promo.promos[0].validRules[0].ruleGetLimit;
  let processed = 0;
  for (let prod of prodList) {
    let count = 0;
    for (let t of prod.tags) {
      if (t.name === tag.name) {
        count = t.count;
      }
    }
    for (let i = 0; i < count; i++) {
      saleList.push({
        prodName: prod.name,
        discountPer: processed < buy ? 0 : 100,
        qty: 1,
        tagName: tag.name,
        key: prod.key,
        index: prod.index,
        type: "FREE",
      });
      processed++;
    }
  }
}

function identifyNonTaggedProducts(tree, prodList, data) {
  for (let prod of tree.products) {
    if (prod.count > 0 || !prod.discountFlag) {
      prodList.push(createSaleEntry(null, prod, data));
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      identifyNonTaggedProducts(value, prodList, data);
    }
  }
}

function createSaleEntry(tag, prod, data) {
  if (tag == null) {
    return {
      prodName: prod.name,
      discountPer: 0,
      customDiscountPer: prod.customDiscountPer,
      customPrice: prod.customPrice,
      includeTaxInAdjustedPrice: prod.includeTaxInAdjustedPrice,
      customDiscountAmount: prod.customDiscountAmount,
      qty: prod.discountFlag ? prod.count : prod.qty,
      key: prod.key,
      index: prod.index,
    };
  }
  if (tag.type == "PERCENTAGE") {
    let qty = 0;
    for (let t of prod.tags) {
      if (t.name === tag.name) {
        qty = t.count;
      }
    }
    return {
      prodName: prod.name,
      discountPer: tag.promo.promos[0].validRules[0].ruleGetLimit,
      qty: qty,
      tagName: tag.name,
      key: prod.key,
      index: prod.index,
      type: tag.type,
    };
  }
  if (tag.type == "PRODUCT_LEVEL_PRICING") {
    let qty = 0;
    for (let t of prod.tags) {
      if (t.name === tag.name) {
        qty = t.count;
      }
    }
    return {
      prodName: prod.name,
      discountPer: 0,
      qty: qty,
      tagName: tag.name,
      key: prod.key,
      index: prod.index,
      type: tag.type,
      productLevelPromotionPrice: prod.productLevelPromotion[tag.id],
    };
  }
}

function identifyTaggedProducts(tag, tree, prodList) {
  for (let prod of tree.products) {
    if (prod.tags) {
      for (let t of prod.tags) {
        if (t.name === tag.name) {
          prodList.push(prod);
        }
      }
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      identifyTaggedProducts(tag, value, prodList);
    }
  }
}

function applyPromotion(tree, data, tags) {
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      for (let i = value.count; i > 0; i--) {
        let cnt = applyPromotionInternalDynamic(value, data, i, tags);
        if (cnt > 0) i++;
      }
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      cleanupValidPromotions(value);
    }
  }
}

function applyPromotionInternalDynamic(tree, data, count, tags) {
  if (tree.count == 0) return 0;
  for (let prod of tree.products) {
    for (let i = prod.count; i >= count; i--) {
      let pr = getPromotion(prod.validPromotions, i, i);
      if (pr) {
        let tag = createTag(tags, pr, "prod_" + prod.name).name;
        if (!prod.tags) {
          prod["tags"] = [];
        }
        prod.tags.push({
          name: tag,
          count: i,
          type: pr.promos[0].validRules[0].ruleType.code,
        });
        prod.count = prod.count - i;
        tree.count = tree.count - i;
        return i;
      }
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      if (value.count > 0) {
        let cnt = applyPromotionInternalDynamic(value, data, count, tags);
        if (cnt > 0) {
          tree.count = tree.count - cnt;
          return cnt;
        }
      }
    }
  }
  for (let i = tree.count; i >= count; i--) {
    let pr = getPromotion(tree.validPromotions, i, i);
    if (pr) {
      let tag = createTag(tags, pr, "cat_" + tree.catType);
      if (!tree["tags"]) {
        tree["tags"] = [];
      }
      let prodList = [];
      identifyAllOpenProducts(tree, prodList);
      let pList = getTagsForProducts(prodList, tag, pr.count);
      let cnt = 0;
      for (let p of pList) {
        cnt = cnt + applyTags(tree, p);
      }
      if (cnt > 0) {
        return cnt;
      }
    }
  }
  return 0;
}

function applyTags(tree, p) {
  if (tree.count == 0) return 0;
  for (let prod of tree.products) {
    if (prod.key == p.key) {
      if (!prod.tags) {
        prod["tags"] = [];
      }
      prod.tags.push({
        name: p.tag.name,
        count: p.count,
        type: p.tag.promo.promos[0].validRules[0].ruleType.code,
        priority: p.priority,
      });
      prod.count = prod.count - p.count;
      tree.count = tree.count - p.count;
      return p.count;
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      if (value.count == 0) return 0;
      let cnt = applyTags(value, p);
      if (cnt > 0) {
        tree.count = tree.count - cnt;
        return cnt;
      }
    }
  }
  return 0;
}

function getTagsForProducts(prodList, tag, count) {
  prodList.sort((a, b) => {
    return parseFloat(b.prod.price) - parseFloat(a.prod.price);
  });
  let pList = [];
  let c = count;

  let priority = 1;
  for (let p of prodList) {
    if (c > 0) {
      if (p.prod.count <= c) {
        pList.push({
          key: p.key,
          count: p.prod.count,
          tag: tag,
          priority: priority,
        });
        c = c - p.prod.count;
      } else {
        pList.push({
          key: p.key,
          count: c,
          tag: tag,
          priority: priority,
        });
        c = 0;
      }
    }
    priority++;
  }
  return pList;
}

function identifyAllOpenProducts(tree, prodList) {
  if (tree.count == 0) return 0;
  for (let prod of tree.products) {
    if (prod.count > 0) {
      prodList.push({ prod: prod, key: prod.key });
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      identifyAllOpenProducts(value, prodList);
    }
  }
}

function cleanupValidPromotions(tree) {
  for (let prod of tree.products) {
    delete prod.validPromotions;
    delete prod.promotions;
  }

  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      cleanupValidPromotions(value);
    }
  }
  delete tree.validPromotions;
  delete tree.promotions;
}

function createTag(tags, pr, prefix) {
  let key = tags.length + 1 + "_" + prefix + "_";
  if (pr.promos[0].validRules[0].ruleType.code == "PERCENTAGE") {
    key =
      key +
      "buy_" +
      pr.promos[0].validRules[0].ruleBuyLimit +
      "_get_" +
      pr.promos[0].validRules[0].ruleGetLimit +
      "_%";
  } else if (
    pr.promos[0].validRules[0].ruleType.code == "PRODUCT_LEVEL_PRICING"
  ) {
    key = key + "PRODUCT_LEVEL_PRICING";
  } else {
    key =
      key +
      "buy_" +
      pr.promos[0].validRules[0].ruleBuyLimit +
      "_get_" +
      pr.promos[0].validRules[0].ruleGetLimit +
      "_free";
  }
  let tag = {
    id: pr.promos[0].id,
    name: key,
    promo: pr,
    type: pr.promos[0].validRules[0].ruleType.code,
  };
  tags.push(tag);
  return tag;
}

function getPromotion(validPromotions, itemCount, count) {
  if (validPromotions && validPromotions.length > 0) {
    for (let p of validPromotions) {
      if (p.count == count && count == itemCount) {
        return p;
      }
    }
  }
  return null;
}

function deriveValidPromotions(tree, data, lookupCount) {
  tree.validPromotions = [];
  if (tree.promotions) {
    if (tree.promotions.length > 0) {
      for (let i = lookupCount; i > 0; i--) {
        let validPromos = getValidPromotions(i, tree.promotions);
        if (validPromos.length > 0)
          tree.validPromotions.push({
            count: i,
            promos: validPromos,
          });
      }
      tree.promotions = null;
    }
  }
  for (let p of tree.products) {
    if (p.promotions && p.promotions.length > 0) {
      p.validPromotions = [];
      for (let i = lookupCount; i > 0; i--) {
        let validPromos = getValidPromotions(i, p.promotions);
        if (validPromos.length > 0)
          p.validPromotions.push({
            count: i,
            promos: validPromos,
          });
      }
      p.promotions = null;
    }
  }
  for (const [key, value] of Object.entries(tree)) {
    if (key.startsWith("--category--")) {
      deriveValidPromotions(value, data, lookupCount);
    }
  }
}

function getValidPromotions(lookupCount, promos) {
  let r = [];

  for (let promo of promos) {
    if (isValidDate(promo)) {
      let validRules = [];
      for (let p of promo.ruleConfigList) {
        if (p.ruleType.code == "PRODUCT_LEVEL_PRICING") {
          validRules.push(p);
        } else {
          let bundleQty =
            p.ruleType.code == "PERCENTAGE"
              ? parseFloat(p.ruleBuyLimit)
              : parseFloat(p.ruleBuyLimit) + parseFloat(p.ruleGetLimit);
          if (bundleQty == lookupCount) validRules.push(p);
        }
      }
      if (validRules.length > 0) {
        r.push({
          count: lookupCount,
          validRules: validRules,
          name: promo.policyName,
          id: promo.id,
        });
      }
    }
  }

  return r;
}

function getPromotions(dbPromos, promoIds) {
  let res = [];
  if (promoIds)
    for (let d of dbPromos) {
      for (let p of promoIds) {
        if (p == d.id) {
          d.selectedDateList = [];
          res.push(d);
        }
      }
    }
  return res;
}
function getCategory(dbCategory, catId) {
  for (let cat of dbCategory) {
    if (cat.id == catId) {
      return cat;
    }
  }
}

function refreshTree(data, root) {
  let count = 0;
  if (!root) return 0;
  for (const [key, value] of Object.entries(root)) {
    if (key.startsWith("--category--")) {
      let cnt = refreshTree(data, root[key]);
      for (let prod of value.products) {
        cnt = cnt + prod.count;
      }
      value.count = cnt;
      count = count + cnt;
    }
  }
  return count;
}

function isValidDate(promo) {
  let today = new Date();
  let fromDate = new Date(promo.fromDate);
  let toDate = new Date(promo.toDate);

  fromDate.setHours(0, 0, 0);
  toDate.setHours(23, 59, 59);

  if (fromDate <= today && today <= toDate) {
    if (promo.policyMode.code === "WEEK") {
      var days = [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
      ];
      var dayName = days[today.getDay()];
      if (promo.selectedWeek) {
        for (let weekDay of promo.selectedWeek) {
          if (dayName === weekDay) {
            return true;
          }
        }
      }
    } else if (promo.policyMode.code === "DATE") {
      if (promo.selectedDateList) {
        for (let date of promo.selectedDateList) {
          if (date.value == today.getDate() && date.isSelected) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

async function updateSaleData(
  data,
  key,
  currencyDecimal,
  colorPallet,
  changeReturnFlag,
  context
) {
  let cats = new Set();
  let promos = new Set();

  for (let d of data) {
    if (d.productBean.deptId) {
      cats.add(d.productBean.deptId);
    }
    if (d.productBean.subDeptId) {
      cats.add(d.productBean.subDeptId);
    }
    if (d.productBean.catId) {
      cats.add(d.productBean.catId);
    }
    if (d.productBean.subCatId) {
      cats.add(d.productBean.subCatId);
    }
    for (let p of d.pricingBean.promotionIds) {
      promos.add(p);
    }
  }

  let dbCats = await db.category.where("id").anyOf(cats).toArray();
  for (let cat of dbCats) {
    if (cat.promotionIds) {
      for (let p of cat.promotionIds) {
        promos.add(p);
      }
    }
  }

  let dbPromos = await db.promotion.where("id").anyOf(promos).toArray();

  let tree = {};
  let ix = 0;
  for (let d of data) {
    let p = d.productBean;
    let discountFlag = d.discountFlag;
    if (d.customPrice) {
      discountFlag = false;
    }
    if (d.customDiscountPer) {
      discountFlag = false;
    }
    if (d.customDiscountAmount) {
      discountFlag = false;
    }
    if (p.deptId) {
      if (!tree["--category--" + p.deptId]) {
        tree["--category--" + p.deptId] = {
          treeType: "category",
          catType: "dept",
          promotions: getPromotions(
            dbPromos,
            getCategory(dbCats, p.deptId).promotionIds
          ),
          products: [],
        };
      }
      if (!p.subDeptId) {
        tree["--category--" + p.deptId].products.push({
          name: p.name,
          promotions: getPromotions(dbPromos, d.pricingBean.promotionIds),
          productLevelPromotion: d.pricingBean.productLevelPromotion,
          index: ix,
          count: discountFlag ? d.qty : 0,
          key: d.key,
          qty: d.qty,
          discountFlag: discountFlag,
          customPrice: d.customPrice,
          includeTaxInAdjustedPrice: d.includeTaxInAdjustedPrice,
          customDiscountPer: d.customDiscountPer,
          customDiscountAmount: d.customDiscountAmount,
        });
      }
    }
    if (p.subDeptId) {
      if (!tree["--category--" + p.deptId]["--category--" + p.subDeptId]) {
        tree["--category--" + p.deptId]["--category--" + p.subDeptId] = {
          treeType: "category",
          catType: "subDept",
          promotions: getPromotions(
            dbPromos,
            getCategory(dbCats, p.subDeptId).promotionIds
          ),
          products: [],
        };
      }
      if (!p.catId) {
        tree["--category--" + p.deptId][
          "--category--" + p.subDeptId
        ].products.push({
          name: p.name,
          promotions: getPromotions(dbPromos, d.pricingBean.promotionIds),
          productLevelPromotion: d.pricingBean.productLevelPromotion,
          index: ix,
          count: discountFlag ? d.qty : 0,
          key: d.key,
          qty: d.qty,
          discountFlag: discountFlag,
          customPrice: d.customPrice,
          includeTaxInAdjustedPrice: d.includeTaxInAdjustedPrice,
          customDiscountPer: d.customDiscountPer,
          customDiscountAmount: d.customDiscountAmount,
        });
      }
    }
    if (p.catId) {
      if (
        !tree["--category--" + p.deptId]["--category--" + p.subDeptId][
          "--category--" + p.catId
        ]
      ) {
        tree["--category--" + p.deptId]["--category--" + p.subDeptId][
          "--category--" + p.catId
        ] = {
          treeType: "category",
          catType: "cat",
          promotions: getPromotions(
            dbPromos,
            getCategory(dbCats, p.catId).promotionIds
          ),
          products: [],
        };
      }
      if (!p.subCatId) {
        tree["--category--" + p.deptId]["--category--" + p.subDeptId][
          "--category--" + p.catId
        ].products.push({
          name: p.name,
          promotions: getPromotions(dbPromos, d.pricingBean.promotionIds),
          productLevelPromotion: d.pricingBean.productLevelPromotion,
          index: ix,
          count: discountFlag ? d.qty : 0,
          key: d.key,
          qty: d.qty,
          discountFlag: discountFlag,
          customPrice: d.customPrice,
          includeTaxInAdjustedPrice: d.includeTaxInAdjustedPrice,
          customDiscountPer: d.customDiscountPer,
          customDiscountAmount: d.customDiscountAmount,
        });
      }
    }
    if (p.subCatId) {
      if (
        !tree["--category--" + p.deptId]["--category--" + p.subDeptId][
          "--category--" + p.catId
        ]["--category--" + p.subCatId]
      ) {
        tree["--category--" + p.deptId]["--category--" + p.subDeptId][
          "--category--" + p.catId
        ]["--category--" + p.subCatId] = {
          treeType: "category",
          catType: "dept",
          promotions: getPromotions(
            dbPromos,
            getCategory(dbCats, p.subCatId).promotionIds
          ),
          products: [],
        };
      }
      tree["--category--" + p.deptId]["--category--" + p.subDeptId][
        "--category--" + p.catId
      ]["--category--" + p.subCatId].products.push({
        name: p.name,
        promotions: getPromotions(dbPromos, d.pricingBean.promotionIds),
        productLevelPromotion: d.pricingBean.productLevelPromotion,
        index: ix,
        count: discountFlag ? d.qty : 0,
        key: d.key,
        qty: d.qty,
        discountFlag: discountFlag,
        customPrice: d.customPrice,
        includeTaxInAdjustedPrice: d.includeTaxInAdjustedPrice,
        customDiscountPer: d.customDiscountPer,
        customDiscountAmount: d.customDiscountAmount,
      });
    }
    ix++;
  }

  var t0 = performance.now();
  try {
    applyPromotionPhase1(tree, data);
    let tags = [];
    let saleData = await applyPromotionWrapper(
      tree,
      data,
      tags,
      currencyDecimal,
      colorPallet,
      key,
      context
    );
    if (changeReturnFlag) changeReturnFlag(false);
    return saleData;
  } catch (err) {
    console.error("ERROR", err);
  }
}

async function isSaleAllowed(
  saleSetting,
  setAlert,
  translate,
  context,
  productBean,
  pricingBean,
  newPrice,
  promotionPer,
  promotionAmount,
  returnFlag
) {
  if (!returnFlag && saleSetting.preventZeroStockSale) {
    if (productBean.isStockItem && !productBean.stockAvailable) {
      setAlert({
        show: true,
        title: "Alert!",
        message: translate("Zero stock sale is not allowed"),
        sound: true,
      });
      return false;
    }
  }
  if (!returnFlag && saleSetting.preventBelowCostSale) {
    let includeTax = productBean.includeTaxInPrice;
    let price = pricingBean.price;
    let promotion = 0;
    let discounted = productBean.isDiscounted;
    if (newPrice) {
      includeTax = saleSetting.includeTaxInAdjustedPrice
        ? saleSetting.includeTaxInAdjustedPrice
        : false;
      price = newPrice;
      discounted = true;
    }
    if (promotionPer) {
      promotion = promotionPer;
      discounted = true;
    }

    if (promotionAmount) {
      promotion = (parseFloat(promotionAmount) / parseFloat(price)) * 100;
      discounted = true;
    }

    let dbCost = await db.cost
      .where("productId")
      .equals(productBean.id)
      .toArray();

    console.log("dbCOst", dbCost);
    let cost = 0;
    if (dbCost.length > 0) {
      cost = dbCost[0].cost;
    }

    let result = PricingUtils.derivePrice(
      context.store.currencyDecimal,
      cost,
      price,
      includeTax,
      productBean.taxBean.rate,
      productBean.includeDiscountInPrice,
      promotion,
      null,
      discounted,
      1,
      false
    );

    if (parseFloat(result.cost) > parseFloat(result.retailSalePrice)) {
      setAlert({
        show: true,
        title: "Alert!",
        message: translate("Price lower than cost is not allowed"),
        sound: true,
      });
      return false;
    }
  }
  return true;
}

async function updateProduct(
  position,
  eventType,
  value,
  rawData,
  screenData,
  context,
  setAlert,
  translate
) {
  let key = "";
  if ("addQty" === eventType) {
    rawData[position].qty = rawData[position].qty + value;
    key = rawData[position].key;
  }
  if ("updateQty" === eventType) {
    let selectedKey = screenData[position][9].info.key;
    let rawDataPoition = getPositionByKeyFromInternalList(rawData, selectedKey);
    rawData[rawDataPoition].qty = parseFloat(value);
    key = selectedKey;
  }
  if ("updatePrice" === eventType) {
    let customPrice = value;

    if (
      !(await isSaleAllowed(
        context.saleSetting,
        setAlert,
        translate,
        context,
        screenData[position][9].info.productBean,
        screenData[position][9].info.pricingBean,
        customPrice,
        null,
        null,
        screenData[position][9].info.returnFlag
      ))
    ) {
      return;
    }

    /*if (context.saleSetting.includeTaxInAdjustedPrice) {
      if (
        parseFloat(screenData[position][9].info.productBean.taxBean.rate) > 0
      ) {
        customPrice = PricingUtils.formattedNumber(
          value /
            (1 +
              parseFloat(
                screenData[position][9].info.productBean.taxBean.rate
              ) /
                100),
          context.store.currencyDecimal
        );
      }
    }*/

    let selectedKey = screenData[position][9].info.key;
    let rawDataPoition = getPositionByKeyFromInternalList(rawData, selectedKey);
    rawData[rawDataPoition].customPrice = parseFloat(customPrice);
    rawData[rawDataPoition].includeTaxInAdjustedPrice =
      context.saleSetting.includeTaxInAdjustedPrice;
    rawData[rawDataPoition].customDiscountPer = null;
    rawData[rawDataPoition].customDiscountAmount = null;

    key = selectedKey;
  }
  if ("updateDiscountPer" === eventType) {
    if (
      !(await isSaleAllowed(
        context.saleSetting,
        setAlert,
        translate,
        context,
        screenData[position][9].info.productBean,
        screenData[position][9].info.pricingBean,
        null,
        parseFloat(value),
        null,
        screenData[position][9].info.returnFlag
      ))
    ) {
      return;
    }

    let selectedKey = screenData[position][9].info.key;
    let rawDataPoition = getPositionByKeyFromInternalList(rawData, selectedKey);
    rawData[rawDataPoition].customPrice = null;
    rawData[rawDataPoition].customDiscountPer = parseFloat(value);
    rawData[rawDataPoition].customDiscountAmount = null;

    key = selectedKey;
  }
  if ("updateDiscountAmount" === eventType) {
    if (
      !(await isSaleAllowed(
        context.saleSetting,
        setAlert,
        translate,
        context,
        screenData[position][9].info.productBean,
        screenData[position][9].info.pricingBean,
        null,
        null,
        value,
        screenData[position][9].info.returnFlag
      ))
    ) {
      return;
    }

    let selectedKey = screenData[position][9].info.key;
    let rawDataPoition = getPositionByKeyFromInternalList(rawData, selectedKey);
    rawData[rawDataPoition].customPrice = null;
    rawData[rawDataPoition].customDiscountPer = null;
    rawData[rawDataPoition].customDiscountAmount = parseFloat(value);

    key = selectedKey;
  }
  if (eventType === "serviceDetails") {
    let selectedKey = screenData[position][9].info.key;
    let rawDataPoition = getPositionByKeyFromInternalList(rawData, selectedKey);
    rawData[rawDataPoition].info.serviceMeta = value;
  }
  return { rawData: rawData, key: key };
}

function getPositionByKeyFromInternalList(data, key) {
  let ix = 0;
  for (let d of data) {
    if (key === d.key) return ix;
    ix++;
  }
  return null;
}

async function getStoreCostingMethodeCode() {
  let costingMethodeCode = "AVERAGE";
  try {
    let storeAdminVal = await db.setting
      .where("sKey")
      .equals("store_admin")
      .toArray();
    if (storeAdminVal && storeAdminVal[0] && storeAdminVal[0].sValue) {
      let storeSettings = JSON.parse(storeAdminVal[0].sValue);
      if (storeSettings.costingMethodeCode)
        costingMethodeCode = storeSettings.costingMethodeCode;
    }
  } catch (err) {
    console.log("ERROR-", "Costing methode not found");
  } finally {
    return costingMethodeCode;
  }
}
